import {
	GovCard,
	GovFlex,
	GovGrid,
	GovGridItem,
	GovSkeleton,
} from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const Skeleton = ({ code }: { code: string }) => {
	const { t } = useLocale(code);

	const wcagLabel = t('loading.wcag.processing', {
		namespace: LocalizeNameSpaceTypes.Global,
	});

	return (
		<GovGrid gap="l">
			<GovGridItem column="12">
				<GovCard>
					<LayoutGap gap="s">
						<GovFlex
							justifyContent="space-between"
							alignItems="center"
							responsive="false"
							className="mb-2!">
							<GovSkeleton
								width="230px"
								height="27px"
								aria-label={wcagLabel}
							/>
							<GovSkeleton
								shape="circle"
								width="27px"
								height="27px"
								aria-label={wcagLabel}
							/>
						</GovFlex>
						<div>
							<GovSkeleton
								width="100%"
								height="20px"
								className="shrink-0"
								aria-label={wcagLabel}
							/>
							<GovSkeleton
								width="50%"
								height="20px"
								className="shrink-0"
								aria-label={wcagLabel}
							/>
						</div>
						<GovSkeleton
							width="70px"
							height="24px"
							className="shrink-0"
							aria-label={wcagLabel}
						/>
					</LayoutGap>
				</GovCard>
			</GovGridItem>
		</GovGrid>
	);
};
